import CachedIcon from '@mui/icons-material/Cached';
import DownloadIcon from '@mui/icons-material/Download';
import { styled, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import BayerModal from '/@/components/bayer/modal';
import { _ } from '/@/locale';

const SpinningCachedIcon = styled(CachedIcon)({
    animation: 'spin 1s linear infinite',
    '@keyframes spin': {
        '0%': {
            transform: 'rotate(0deg)',
        },
        '100%': {
            transform: 'rotate(360deg)',
        },
    },
});

const DownloadPopup = ({
    visible,
    onClose,
    title,
    onDownloadBefore,
    onDownloadAfter,
    beforeDownload,
    afterDownload,
}: {
    visible: boolean;
    onClose: () => void;
    title: string;
    onDownloadBefore: (file: File | undefined) => Promise<File>;
    onDownloadAfter: () => void;
    beforeDownload: string;
    afterDownload: string;
}) => {
    const [file, setFile] = useState<File | undefined>(undefined);

    useEffect(() => {
        const handleDownload = async () => {
            try {
                const newFile = await onDownloadBefore(file);
                setFile(newFile);
            } catch (error) {
                enqueueSnackbar(_('Ha ocurrido un error, por favor inténtalo más tarde.'), {
                    variant: 'error',
                });
            }
        };
        if (visible) {
            handleDownload();
        }
    }, [visible]);

    return (
        <BayerModal
            variant='children'
            open={visible}
            setClose={onClose}
            title={title}
            buttonText={
                file ? (
                    <Grid2 container spacing={1} justifyContent='center' alignItems='center'>
                        <Grid2 container>
                            <DownloadIcon />
                        </Grid2>
                        <Grid2>{_('Descargar')}</Grid2>
                    </Grid2>
                ) : (
                    <Grid2 container justifyContent='center' alignItems='center' spacing={1}>
                        <Grid2 container>
                            <SpinningCachedIcon />
                        </Grid2>
                        <Grid2>{_('Generando')}</Grid2>
                    </Grid2>
                )
            }
            handleClick={() => {
                onDownloadAfter();
                if (file) {
                    window.open(file?.url);
                }
            }}
            disabled={!file}
        >
            <Typography sx={{ p: 3 }} color='primary' align='center' variant='subtitle1'>
                {file ? afterDownload : beforeDownload}
            </Typography>
        </BayerModal>
    );
};

export default DownloadPopup;
